export const tr = {
    age_0_17: '0 - 17',
    age_18_24: '17 - 24',
    age_25_34: '25 - 35',
    age_35_44: '35 - 44',
    age_45_54: '45 - 54',
    age_45_inf: '45 yaş üstü',
    age_55_inf: '55 yaş üstü',
    any: 'herhangi',
    'gender-and-age': 'cinsiyet: {gender}, yaş: {age}',
    gender_any: 'herhangi',
    gender_female: 'kadın',
    gender_male: 'erkek',
    'on-condition': '"{condition}" koşuluna göre'
};
